import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import { Button } from '#/modules/commonComponents/button';
import { DESTRUCTIVE_SOLID_BUTTON_CLASS } from '#/modules/imsMgmt/receipts/shared/destructiveSolidButtonClass';

/**
 * 列表 SideMsg workflow 按鈕（列印／提交／核准／退回／刪除草稿）。
 * Confirm／退回 Dialog／mutation／Excel 下載由呼叫端處理。
 * 區塊分隔交由 SideMsg `side_msg-content-block`。
 */
const DocumentSideMsgActions = ({
  canPrint = false,
  canSubmit = false,
  canApprove = false,
  canReject = false,
  canCancel = false,
  isPending = false,
  isPrintPending = false,
  onPrint,
  onSubmit,
  onApprove,
  onReject,
  onCancel,
}) => {
  const hasActions = canPrint || canSubmit || canApprove || canReject || canCancel;
  if (!hasActions) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {canPrint ? (
        <Button
          type="button"
          variant="outline"
          disabled={isPrintPending}
          onClick={onPrint}
        >
          {isPrintPending ? '下載中…' : '列印'}
        </Button>
      ) : null}
      {canSubmit ? (
        <Button type="button" disabled={isPending} onClick={onSubmit}>
          提交
        </Button>
      ) : null}
      {canApprove ? (
        <Button type="button" disabled={isPending} onClick={onApprove}>
          核准
        </Button>
      ) : null}
      {canReject ? (
        <Button
          type="button"
          variant="destructive"
          className={cn(DESTRUCTIVE_SOLID_BUTTON_CLASS)}
          disabled={isPending}
          onClick={onReject}
        >
          退回
        </Button>
      ) : null}
      {canCancel ? (
        <Button
          type="button"
          variant="destructive"
          className={cn(DESTRUCTIVE_SOLID_BUTTON_CLASS)}
          disabled={isPending}
          onClick={onCancel}
        >
          刪除草稿
        </Button>
      ) : null}
    </div>
  );
};

DocumentSideMsgActions.propTypes = {
  canPrint: PropTypes.bool,
  canSubmit: PropTypes.bool,
  canApprove: PropTypes.bool,
  canReject: PropTypes.bool,
  canCancel: PropTypes.bool,
  isPending: PropTypes.bool,
  isPrintPending: PropTypes.bool,
  onPrint: PropTypes.func,
  onSubmit: PropTypes.func,
  onApprove: PropTypes.func,
  onReject: PropTypes.func,
  onCancel: PropTypes.func,
};

export default DocumentSideMsgActions;
